import type { FaireProductEntity } from "../../entity_types/product";

export const p_h6hrktnfwy: FaireProductEntity = {
  token: "p_h6hrktnfwy",
  type: "product",
  name: "Wrapped Raffia Drop Statement Earrings - Southern Jewelry",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/0a6a668004ba5772ba65b5950e16322c7401191767fa934bf6c647c682ee3e97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83bdac680c99028a19c64087da3b2e6d4088abce2a664f239145160770ad6cc3.jpeg",
    "https://cdn.faire.com/fastly/e9fc3bb4f0987cbf87bdf393cbbc2acf6c83677984e350766a791e7a473b27ff.jpeg",
    "https://cdn.faire.com/fastly/2e100843fc60bf288b1cea538b32f6a1d1168b568b73e1721e229101b17a5089.jpeg",
    "https://cdn.faire.com/fastly/991c0d406e675aa4ad871a7a3edc71d40fc2711dc6214ffb6086b4cec55b2a12.jpeg",
    "https://cdn.faire.com/fastly/6c024307ad8346c7aa88e818fda46e57a3806cb9aac8ca2ccea67b99229421ef.jpeg",
    "https://cdn.faire.com/fastly/d5070216cdf60c4838bceed26ae33fa76bb24cd25faa3a9b513f4081a9280267.jpeg",
    "https://cdn.faire.com/fastly/6a7d4eba7cf55f1ee67797d883a7bdfe1385fad33e341ca9c5821971c9d2aefe.jpeg",
    "https://cdn.faire.com/fastly/86a1a949d48d32ec9169065ffc9697dc6fdb38fafbde4431ee299a6c20da037a.jpeg",
    "https://cdn.faire.com/fastly/ad1a118adc4a30ae10f1f0549cbea3aa03ac640692abec39fe617d5c187c3bd4.jpeg"
  ],
  priceDollars: 14,
  description: "Wrapped Raffia Drop Statement Earrings - Brookhaven Baubles - Southern Statement Jewelry - Raffia Statement Earrings\n\nWrapped Raffia Drop Statement Earrings - Southern Statement Jewelry - Raffia Statement Earrings - Fashion Earrings for Her\n\nAvailable in 9 colors! White, Natural, Hot Pink, Lavender, Light Blue, Blue, Yellow, Orange, & Turquoise.\n\nOur earrings are the perfect statement for any occasion or outfit! Style with a basic tee or dress up your fit with our statement earrings. They are great for every day, a night on the town, weddings, wedding guests, bridal showers, bachelorettes, moms, co-workers, birthday gifts, beach vacations, and more! Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:06.081Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
